import AppSimpleBar from "components/AppSimpleBar";
import classnames from "classnames";
import { Utils } from "helpers/utils";
import { useRedux } from "hooks";
import { createSelector } from "reselect";
import { APIClient } from "../../../api/apiCore";
import * as urls from "../../../api/urls";
import { useEffect, useState } from "react";

const Content2SOnlinePendingDO = () => {
  const { dispatch, useAppSelector } = useRedux();
  const storeData = createSelector(
    (state: any) => state.Chats,
    (state: any) => state.Profile2,
    (state, p2) => ({
      selectedContentTitle: state.selectedContentTitle,
      selectedContentTitleLoading: state.selectedContentTitleLoading,
      contentTitles: state.contentTitles ?? [],
      contentTitleInfo: state.contentTitleInfo ?? {},
      custContents: state.custContents,
      selectedContentTitleKey: state.selectedContentTitleKey,
      activeGroupId: p2.activeGroupId,
    })
  );
  // Inside your component
  const {
    selectedContentTitle, selectedContentTitleLoading, contentTitles, contentTitleInfo
    , custContents, activeGroupId, selectedContentTitleKey
  } = useAppSelector(storeData);

  const [products, setProducts] = useState<any[]>([]);
  const [selTitle, setSelTitle] = useState<any>({});
  const [selSoCode, setSelSoCode] = useState<string>("");

  const onClickEachOrder = async (title: any) => {
    try {
      // console.log('sel title:', title);
      const api = new APIClient();
      setSelSoCode(title.soCode);
      api.fnPostForm(urls.GET_CONTENT_ORDER_GET_PENDING_DETAIL, {
        userOrGroupId: activeGroupId,
        soCode: title.soCode,
        soBranchId: title.soBranchID
      })
        .then(rs => {
          setSelTitle(title);
          setProducts(rs);
        })
        .catch(e2 => Utils.HandleException(e2, true));
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }

  useEffect(() => {
    if (window.innerWidth >= 992 && contentTitles.length > 0) {
      onClickEachOrder(contentTitles[0]);
    }
  }, []);

  const SpanUnit: React.FC<{ value: number, unit: string }> = ({ value, unit }) => {
    // return (<span style={{ width: "120px", minWidth: "120px" }}>{caption}</span>);
    return (
      <div className="d-flex justify-content-between">
        <div>{Utils.FormatNumber(value, 2)}</div>
        <div style={{ width: "40px", textAlign: "right" }}>{unit}</div>
      </div>
    )
  }

  // console.log('contentTitles:', contentTitles);

  return (
    <div className="d-flex justify-content-start p-3" style={{ gap: "20px" }}>

      <div className={classnames("cus-content2div-list", { "cus-content2div-list-hide": products.length > 0 })}>
        <div className="text-primary fz-11 mb-2" style={{ borderBottom: "solid 1px var(--bs-primary)" }}>
          {contentTitles.length <= 0 ? (<>ไม่มีข้อมูล...</>) : (<>&nbsp;คำสั่งซื้อ {contentTitles.length} รายการ...</>)}
        </div>

        {contentTitles.length > 0 && (
          <AppSimpleBar style={{ height: "calc(100vh - 200px)" }} >
            <ul className="list-unstyled" >
              {contentTitles.map((title: any, key: number) =>
                <li key={key} className={classnames("mb-2 p-1 hand hover ", { "active-primary": title.soCode == selSoCode })} onClick={() => onClickEachOrder(title)}>
                  <div className="d-flex justify-content-between">
                    <div className="d-flex justify-content-start align-items-center">
                      <div><i className="fas fa-shopping-cart fz-14 pe-2"></i></div>
                      <div>
                        <div className="">
                          {/* {title.soCode} */}
                          {title.refNo}
                        </div>
                        <div className="fz-09 text-secondary p-0" style={{ lineHeight: "0.9em" }}>
                          {/* <i className={classnames("fab fa-paypal", { "text-primary": title.soIsPay, "text-secondary": !title.soIsPay })}></i> {title.refNo} */}
                          {Utils.GetDMY(title.soDeliveryDate)}
                        </div>
                      </div>
                    </div>
                    <div style={{ textAlign: "right" }}>
                      <div className={classnames({ "text-primary": title.soIsPay, "text-danger": !title.soIsPay })}>
                        {/* {Utils.FormatNumber(title.nonDeliveryWeight, 2)} Kg */}
                        {Utils.FormatNumber(title.soNetbal, 2)} <span className="fz-08">บาท</span>

                      </div>
                      <div className="fz-09 text-secondary p-0" style={{ lineHeight: "0.9em" }}>
                        {/* {Utils.GetDMY(title.soDeliveryDate)} */}
                        {!title.soIsPay && (<>รอชำระเงิน</>)}
                      </div>
                    </div>
                  </div>
                </li>
              )}
            </ul>
          </AppSimpleBar>
        )}
      </div>

      <div className={classnames("cus-content2div-dtl", { "cus-content2div-dtl-hide": products.length <= 0 })} style={{ flex: "1" }}>
        <div className="text-primary fz-11 mb-2" style={{ borderBottom: "solid 1px var(--bs-primary)", position: "relative" }}>
          <i className="fas fa-caret-square-left hand cus-content2div-dtl-back" style={{ position: "absolute", fontSize: "1.8em", top: "-4px" }} onClick={() => setProducts([])}></i>
          <span className="cus-content2div-dtl-title" >
            {/* {products.length <= 0 ? (<>ยังไม่ได้เลือกคำสั่งซื้อ...</>) : (<>{selTitle.soCode}, REF:{selTitle.refNo}</>)} */}
            {products.length <= 0 ? (<>ยังไม่ได้เลือกคำสั่งซื้อ...</>) : (
              <>
                {/* {selTitle.soCode} */}
                {selTitle.refNo}
                &nbsp;&nbsp;
                <span className={classnames({ "text-primary": selTitle.soIsPay, "text-danger": !selTitle.soIsPay })}>
                  <i className={classnames("fab fa-paypal")}></i>
                  &nbsp;
                  {selTitle.soIsPay ? (<>ชำระแล้ว</>) : (<>รอชำระเงิน</>)}
                </span>
              </>
            )}
          </span>
        </div>
        {products.map((prd: any, index: number) => (
          <div key={index} className="d-flex justify-content-between hover mb-3" style={{ borderBottom: "dashed 1px var(--m2-line-divider-color)" }}>
            <div>
              <div>{index + 1}.&nbsp;{prd.productName}</div>
              <div className="ps-3 fz-09 text-secondary">จำนวน {Utils.FormatNumber(prd.nonDeliveryQuan, 2)}&nbsp;{prd.productUnit}</div>
            </div>
            {/* <div><SpanUnit value={prd.priceExcVat} caption="บาท" /></div> */}
            <SpanUnit value={prd.priceExcVat} unit="บาท" />
          </div>
        ))}
        {products.length > 0 && (
          <>
            <div className="d-flex justify-content-between hover mb-6">
              <div><div>น้ำหนักรวม</div></div>
              <SpanUnit value={selTitle.nonDeliveryWeight} unit="กก" />
            </div>
            <div className="d-flex justify-content-between hover mb-6">
              <div><div>ราคารวม</div></div>
              <SpanUnit value={selTitle.soNetTotal} unit="บาท" />
            </div>
            <div className="d-flex justify-content-between hover mb-6">
              <div><div>ภาษี {selTitle.soVatRate} %</div></div>
              <SpanUnit value={selTitle.soVatBal} unit="บาท" />
            </div>
            <div className="d-flex justify-content-between hover mb-6 text-blue" style={{ fontWeight: "bold" }}>
              <div><div>ยอดรวม</div></div>
              <SpanUnit value={selTitle.soNetbal} unit="บาท" />
            </div>
            {(selTitle.socuS_DCName) && (
              <div className="d-flex justify-content-between hover mb-6 text-blue" style={{ marginTop: "20px" }}>
                รับสินค้า {Utils.GetDMYHHMM(selTitle.soDeliveryDate)} {selTitle.socuS_DCName}
              </div>
            )}

            {!selTitle.soIsPay && (
              <div className="d-flex justify-content-between mb-6 text-blue" style={{ fontWeight: "bold", marginTop: "40px", }}>
                <div>
                  <div>
                    {selTitle.paymentURL && (
                      <a href={selTitle.paymentURL} target="_2sonlineqr">
                        <button className="btn btn-outline-danger fz-13" style={{ padding: "3px 10px" }} ><i className='fab fa-paypal'></i> ชำระเงิน</button>
                      </a>
                    )}
                  </div>
                </div>
                {/* <SpanUnit value={selTitle.soNetbal} unit="บาท" /> */}
              </div>
            )}
          </>
        )}
      </div>

    </div>
  );
}

export default Content2SOnlinePendingDO;